import { render, staticRenderFns } from "./FormStockItem.vue?vue&type=template&id=fb3f3c82"
import script from "./FormStockItem.vue?vue&type=script&lang=js"
export * from "./FormStockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormStockItem.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3f3c82')) {
      api.createRecord('fb3f3c82', component.options)
    } else {
      api.reload('fb3f3c82', component.options)
    }
    module.hot.accept("./FormStockItem.vue?vue&type=template&id=fb3f3c82", function () {
      api.rerender('fb3f3c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormStockItem.vue"
export default component.exports